import React from 'react';
export function EmotionalLead() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-55">
      <div className="max-w-[680px] mx-auto font-body" data-id="element-56">
        {/* Opening quote */}
        <p className="text-xl md:text-2xl font-bold text-dark-gray leading-relaxed mb-8" data-id="element-57">
          "Sé exactamente cuántos tutoriales tenés guardados que nunca vas a
          ver."
        </p>

        {/* Emotional copy */}
        <div className="space-y-5 text-dark-gray text-base md:text-lg leading-relaxed" data-id="element-58">
          <p data-id="element-59">Te dijiste a vos misma "este verano aprendo a tejer".</p>
          <p data-id="element-60">
            Compraste el hilo. Tal vez la aguja. Te sentaste, abriste YouTube, y
            8 minutos después estabas más confundida que cuando empezaste.
          </p>
          <p data-id="element-61">Así que cerraste la pestaña. Otra vez.</p>
          <p data-id="element-62">
            Y esa vocecita en tu cabeza dijo: "Quizás yo simplemente no soy el
            tipo de persona que puede hacer esto."
          </p>
          <p className="font-semibold" data-id="element-63">Acá está lo que nadie te dice:</p>
          <p data-id="element-64">
            No fallaste en el crochet. Los tutoriales de crochet te fallaron a
            vos.
          </p>
          <p data-id="element-65">
            Están hechos por expertas que olvidaron lo que se siente ser
            principiante. Usan abreviaciones técnicas que nadie explica. Van
            demasiado rápido. Asumen que ya sabés cosas que no sabés.
          </p>
          <p data-id="element-66">
            El resultado: miles de mujeres abandonan algo que genuinamente aman
            — no porque les falte talento, sino porque nunca tuvieron el punto
            de partida correcto.
          </p>
          <p className="font-bold text-pink-dark text-lg md:text-xl" data-id="element-67">
            Hasta ahora.
          </p>
        </div>
      </div>
    </section>;
}